import React, { useRef, useState } from 'react';
import { Stack, TextField } from '@origin-digital/ods-core';
import { useAddressSearch } from './useAddressSearch';
import { IOriginAddressMeter } from '../fetchers';
import { AddressMeterSearch } from './AddressMeterSearch';

export interface IMeterSearch {
  endpoint: string;
  onConfirm: (address: IOriginAddressMeter) => void;
}

export const AddressMIRNSearch: React.FC<IMeterSearch> = ({ endpoint, onConfirm }) => {
  const {
    data,
    inputError,
    error,
    isSearching,
    isConfirmEnabled,
    validate,
    search,
    resetSearch,
    config,
  } = useAddressSearch(endpoint, 'MIRN');

  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <Stack space="large">
      <TextField
        inputRef={inputRef}
        id="mirn-search"
        label={config.label}
        error={!!inputError}
        value={value}
        helperText={inputError}
        onBlur={({ target }) => validate(target.value)}
        onChange={({ target }) => setValue(target.value)}
        maxLength={config.maxLength}
        hideHelperTextSpace={!!error || isConfirmEnabled}
        endIcon={data && 'success'}
      />
      <AddressMeterSearch
        addressResult={data as IOriginAddressMeter}
        error={error}
        inputRef={inputRef}
        isConfirmEnabled={isConfirmEnabled}
        isLoading={isSearching}
        meterType="MIRN"
        onConfirm={onConfirm}
        onResetSearch={resetSearch}
        onSearch={() => search(value)}
      />
    </Stack>
  );
};
